export default {
  "dashboard.title": "Welcome back",
  "dashboard.noAccount.title": "Add Your PAMM Account",
  "dashboard.noAccount.description": "You need an active investment PAMM account to activate your user and to enjoy the TheClub benefits",
  "dashboard.noAccount.skipButton": "Skip",
  "dashboard.noAccount.addAccountButton": "Add PAMM Account",
  "dashboard.subtitle": "Build your future with The Club",
  "dashboard.totalEarnings.lifetime": "Total Lifetime Earnings",
  "dashboard.totalEarnings.lastMonth": "Total Earnings",
  "dashboard.totalEarnings.breakdown.accounts": "Trading Account Profits",
  "dashboard.totalEarnings.breakdown.commissions": "Your Community Commissions",
  "dashboard.community.combined.title": "My Community Overview",
  "dashboard.userInfo.combined.title": "Profile",
  "dashboard.charts.totalEarningsOverTime": "Total Earnings Over Time",
  "dashboard.userProfile.title": "Profile Overview",
  "dashboard.userProfile.username": "Username",
  "dashboard.userProfile.memberSince": "Member Since",
  "dashboard.userProfile.rank": "Rank",
  "dashboard.userProfile.status": "Status",
  "dashboard.userStats.title": "Quick Stats",
  "dashboard.userStats.referralLink": "Referral Link",
  "dashboard.userStats.commissionModel": "Commission Model",
  "dashboard.userStats.communityValue": "Community Value",
  "dashboard.userStats.linkCopied": "Link Copied!",
  "dashboard.userStats.linkCopiedDesc": "Referral link copied to clipboard",
  "dashboard.userStats.rank": "Rank",
  "dashboard.profits.lifetime": "Trading Account Lifetime Profits",
  "dashboard.profits.lastMonth": "Trading Account Last Month Profits",
  "dashboard.profits.accountsProfits.title": "Trading Account Profits",
  "dashboard.profits.commissions.title": "Your Community Commissions",
  "dashboard.commissions.lifetime": "Lifetime Commissions",
  "dashboard.commissions.lastMonth": "Commissions",
  "dashboard.commissions.lastMonthWithMonth": "Commissions",
  "dashboard.commissions.currentBalance": "Current Balance",
  "dashboard.commissions.totalPaid": "Total Paid",
  "dashboard.community.totalReferrals": "Total Referrals",
  "dashboard.community.totalReferralsDesc": "All Levels Combined",
  "dashboard.community.communityValue": "Your Community Value",
  "dashboard.community.communityValueDesc": "Total Value of your Community",
  "dashboard.mycommunity.title": "My Community",
  "dashboard.charts.profitsOverTime": "Trading Account Profits Over Time",
  "dashboard.charts.commissionsOverTime": "Commissions Over Time",
  "dashboard.charts.accountProfit": "Trading Account Profit",
  "dashboard.charts.totalEarnings": "Total Earnings",
  "dashboard.charts.commissionAmount": "Commission Amount",
  "dashboard.months.jan": "Jan",
  "dashboard.months.feb": "Feb",
  "dashboard.months.mar": "Mar",
  "dashboard.months.apr": "Apr",
  "dashboard.months.may": "May",
  "dashboard.months.jun": "Jun",
  "dashboard.months.jul": "Jul",
  "dashboard.months.aug": "Aug",
  "dashboard.months.sep": "Sep",
  "dashboard.months.oct": "Oct",
  "dashboard.months.nov": "Nov",
  "dashboard.months.dec": "Dec",
  "dashboard.monthsFull.jan": "January",
  "dashboard.monthsFull.feb": "February",
  "dashboard.monthsFull.mar": "March",
  "dashboard.monthsFull.apr": "April",
  "dashboard.monthsFull.may": "May",
  "dashboard.monthsFull.jun": "June",
  "dashboard.monthsFull.jul": "July",
  "dashboard.monthsFull.aug": "August",
  "dashboard.monthsFull.sep": "September",
  "dashboard.monthsFull.oct": "October",
  "dashboard.monthsFull.nov": "November",
  "dashboard.monthsFull.dec": "December",
  "dashboard.loading": "Loading dashboard data...",
  "dashboard.error": "Error loading dashboard data",
  "dashboard.status.active": "Active",
  "dashboard.status.inactive": "Inactive",
  "dashboard.profits.lastMonthWithMonth": "Trading Account Profits",
};
